import React from 'react';
/**
 * Tracks a block's transition from:
 * - not loading -> loading -> loaded -> loading -> loaded -> ...
 * - loading -> loaded -> loading -> loaded -> ...
 *
 * The returned loadingState tracks the current transition.
 *
 * The returned resetLoadingStateOnAnimationEnd function can be used to reset the loading state,
 * for example, when an animation ends. For simplicity, add it to the top-level component wrapper,
 * instead of duplicating it across multiple components.
 *
 * At the moment, used by the Donation and Impact blocks which have a shimmer effect when isLoading
 * is true, as well as a fade-in effect when loading has completed.
 */
export const useLoadingState = (isLoading = false) => {
  const [loadingState, setLoadingState] = React.useState(isLoading ? 'loading' : '');
  const resetLoadingStateOnAnimationEnd = () => setLoadingState('');
  React.useEffect(() => {
    if (isLoading) {
      setLoadingState('loading');
    } else if (loadingState === 'loading') {
      setLoadingState('loaded');
    }
  }, [isLoading, loadingState]);
  return {
    loadingState,
    resetLoadingStateOnAnimationEnd
  };
};